export const SUPPLIERS_QUERY_KEY = 'suppliers'
export const SUPPLIERS_BRIEF_QUERY_KEY = 'suppliersBrief'
export const SUPPLIERS_MUTUAL_SETTLEMENTS = 'suppliersMutualSettlements'
export const ALL_SUPPLIERS_QUERY_KEY = 'allSuppliers'
